import type { MouseEvent } from 'react'
import { useCallback, useMemo } from 'react'

import type { DeeplinkConfig } from '../utils/createDeeplink'
import { createDeeplink } from '../utils/createDeeplink'


export const useDeeplink = (
  deeplink: DeeplinkConfig,
  queryParams: URLSearchParams | null = null,
  isDeeplink = true
) => {
  const link = useMemo(() => {
    return createDeeplink(deeplink, queryParams)
  }, [deeplink, queryParams, isDeeplink])

  const redirect = useCallback(
    (event?: MouseEvent<HTMLElement>) => {
      if (!isDeeplink) {
        return
      }

      event?.preventDefault()
      document.location = createDeeplink(deeplink, queryParams)
    },
    [deeplink, queryParams, isDeeplink]
  )

  return { redirect, link }
}
